"use client";

import {
  FeatureHighlight,
  PriceCalculatorSteps,
} from "@/components/shared/public";
import type { MeasurementServicePricingConfig } from "@/lib/pricing";
import { useTranslations } from "next-intl";
import { floorPlanDetail } from "../../../../public/images/logos";

type PriceCalculationProps = {
  pricingConfig: MeasurementServicePricingConfig;
};

const PriceCalculation = ({ pricingConfig }: PriceCalculationProps) => {
  const t = useTranslations("threeSixtyService");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <div className="flex flex-col">
          <FeatureHighlight
            src={floorPlanDetail}
            alt={"floor plan logo"}
            title={t("priceCalculation")}
            text={""}
          />
          <PriceCalculatorSteps pricingConfig={pricingConfig} />
        </div>
      </div>
    </div>
  );
};

export default PriceCalculation;
